<template>
  <div>
    <div v-for="(item, index) in values">
      <div class="card card-body">
        <div class="col-md-12">
          <h4 class="mt-0">Pergunta {{ index + 1 }}</h4>
          <hr/>
        </div>
        <div class="col-md-12">
          <fg-input 
          type="text" 
          label="Título"
          v-model="item.text"
          @input="updateValue"
          ></fg-input>
        </div>
        
        <!-- Opções -->
        <fg-question-option v-model="item.options" :showButtons="showButtons" :immediateWatch="immediateWatch" :item_id="index" />

        <div class="col-md-12"  v-if="(values.length - 1) == index && showButtons" >
          <button
            v-if="values.length > 1"
            class="btn btn-sm mr-3"
            @click="deleteValue()"
          ><i class="fas fa-minus fa-fw"></i> última pergunta</button>
          <button class="btn btn-primary btn-sm" @click="addValue()"><i class="fas fa-plus fa-fw"></i> pergunta</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fg-question",
  props: {
    showButtons: Boolean,
    immediateWatch: false,
    value: ""
  },
  data() {
    return {
      values: [
        {
          text: "",
          options: []
        }
      ]
    };
  },
  watch: {
    value: function(newData) {
      this.values = newData;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.values);
    },
    deleteValue() {
      let i = this.values.length - 1;
      if (i > 0) {
        this.values.splice(i, 1);
        this.$emit("input", this.values);
      }
    },
    addValue() {
      this.values.push({});
      this.$emit("input", this.values);
    }
  }
};
</script>
<style>
</style>
